import { devtoolsExchange } from '@urql/devtools';
import { cacheExchange } from '@urql/exchange-graphcache';
import { makeDefaultStorage } from '@urql/exchange-graphcache/default-storage';
import { createClient, fetchExchange } from 'urql';
import schema from './generatedIntrospection';
import type { GraphCacheConfig } from './graphql/types';

const storage = makeDefaultStorage({
  idbName: 'juno',
  maxAge: 7,
});

const cache = cacheExchange<GraphCacheConfig>({
  schema,
  storage,
  keys: {
    Permission: () => null,
    EventConfig: () => null,
    XpAudit: () => null,
    ItemMetadata: () => null,
    ItemReproductionMetadata: () => null,
    // CharacterSkill: data => data.characterSkillId ?? '-1',
    CharacterSkill: () => null,
    SkillStatistics: () => null,
    RetirementXp: () => null,
    RetirementPaths: () => null,
    StatStatistics: () => null,
    StatsStatistics: () => null,
    SkillsStatistics: () => null,
    SkillCategoryStatistics: () => null,
    ResidenciesStatistics: () => null,
    Invoice: () => null,
    InvoiceChange: () => null,
    OrganizationConfig: () => null,
    CraftableItem: () => null,
    Inventory: () => null,
    ClearingHouse: () => null,
    Timeline: t => [t.id, t.eventId, t.local].join('-'),
    SkillCategoriesStatistics: () => null,
    CraftingComponent: data =>
      String(data.id) ?? [data.component?.id, data.amount].join('-'),
    CharacterConstraint: () => null,
    ActionLogTally: () => null,
    ItemTransactionTally: () => null,
    ItemClaim: () => null,
    ModChallengeResolutionOption: () => null,
    ModChallengeState: () => null,
    ModParticipantEquipment: () => null,
    ModParticipantLimb: () => null,
    ModParticipantMaskedState: () => null,
    ModParticipantSkillUse: () => null,
    ModParticipantState: () => null,
    ModParticipantStatusEffect: () => null,
    ModParticipantStatusEffectEntity: () => null,
    DiceRollResult: () => null,
    DiceRollSummary: () => null,
    DiceRollDamage: () => null,
    DefenseRoll: () => null,
    DiceRollAutoResolve: () => null,
    Coord: () => null,
  },
  updates: {
    Mutation: {
      destroyEventAttendee: (result, args, cache) => {
        cache.invalidate({
          __typename: 'EventAttendee',
          id: args.input.eventAttendeeId,
        });
        cache.invalidate({
          __typename: 'Ticket',
          id: Number(result.destroyEventAttendee?.eventAttendee?.ticket.id),
        });
      },
    },
  },
});

const graphqlClient = createClient({
  url: import.meta.env.VITE_API_ENDPOINT,
  // urql/@urql/core v6 defaults query operations to GET ('within-url-limit');
  // force POST so requests hit the Rails POST /graphql route.
  preferGetMethod: false,
  exchanges: [devtoolsExchange, cache, fetchExchange],
  fetchOptions() {
    const token = localStorage.getItem('token')?.replace(/"/g, '');

    return token
      ? {
          headers: {
            'X-Auth-Token': token,
            'X-Window-Location': window.location.href,
          },
        }
      : {
          headers: {
            'X-Auth-Token': '0',
            'X-Window-Location': window.location.href,
          },
        };
  },
});

export default graphqlClient;
